import { Card, Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import useWhiteLabeling from "../hooks/useWhiteLabeling";
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from "react-intl";
const messages = defineMessages({
    companyBanner: {
        id: "Yrityksen banneri",
        defaultMessage: "Yrityksen banneri"
    },
    companyBannerImage: {
        id: "Yrityksen bannerikuva",
        defaultMessage: "Yrityksen bannerikuva"
    },
    companyBannerTitle: {
        id: "Yrityksen banneriotsikko",
        defaultMessage: "Yrityksen banneriotsikko"
    },
    companyBannerDescription: {
        id: "Yrityksen bannerikuvaus",
        defaultMessage: "Yrityksen bannerikuvaus"
    }
});

/**
 * CompanyBanner component fetches and displays a banner with title, description, and image.
 *
 * @param {Object} props.banner - The data object containing banner information.
 * @returns {JSX.Element} The rendered CompanyBanner component.
 */
const CompanyBanner = (props) => {
    const [imageUrl, setImageUrl] = useState(null);
    const { fetchWhiteLabelingImageData } = useWhiteLabeling();
    const lng = props.intl.formatMessage;

    const content = Array.isArray(props.banner?.content) ? props.banner.content[0] : undefined;
    const title = content?.title ?? '';
    const description = content?.description ?? '';
    const link = content?.link_url ?? '';
    const linkText = content?.link_text ?? '';
    const bannerName = props.banner?.name ?? '';
    const hasBannerAsset = props.banner?.banner_asset_id !== undefined &&
        props.banner?.banner_asset_id !== null &&
        parseInt(props.banner?.banner_asset_id) !== 0;

    useEffect(() => {
        async function fetchData() {
            const imageUrl = await fetchWhiteLabelingImageData(props.banner?.banner_asset_id);
            setImageUrl(imageUrl);
        }
        void fetchData();
    }, [props.banner]);

    const handleClick = () => {
        if (link !== '') {
            window.open(link, '_blank');
        }
    }

    const shouldShowBody = title !== '' || description !== '' || linkText !== '';

    if (props.banner === undefined) {
        return null;
    }

    return (
        <Card
            id='company-banner'
            className={`company-banner ${link !== '' ? 'clickable' : ''}`}
            onClick={handleClick}
            aria-label={title ? `${lng(messages.companyBanner)} ${title}` : lng(messages.companyBanner)}
        >
            {hasBannerAsset && (
                <div className="company-info">
                    <Card.Img
                        variant="top"
                        src={imageUrl}
                        alt={bannerName}
                        className="rounded-top rounded-bottom"
                        aria-label={bannerName ? `${lng(messages.companyBannerImage)} ${bannerName}` : lng(messages.companyBannerImage)}
                    />
                </div>
            )}
            {shouldShowBody && (
                <Card.Body>
                    <Row>
                        <Col>
                            <Card.Title>
                                <h5 className="mb-0" aria-label={title || lng(messages.companyBannerTitle)}>{ title }</h5>
                            </Card.Title>
                            <Card.Text aria-label={description || lng(messages.companyBannerDescription)}>{ description }</Card.Text>
                        </Col>
                        {linkText !== '' && (
                            <Col
                                xl='auto'
                                className='align-items-center d-flex justify-content-start justify-content-xl-end'
                            >
                                <a rel="noopener noreferrer"
                                   href={ link } target="_blank"
                                   className="dataPrivacy-link company-link"
                                   aria-label={ linkText }
                                >
                                    { linkText }
                                </a>
                            </Col>
                        )}
                    </Row>
                </Card.Body>
            )}
        </Card>
    )
};

CompanyBanner.propTypes = {
    intl: PropTypes.object.isRequired,
    banner: PropTypes.object
};

export default injectIntl(CompanyBanner);
